import styled from '@emotion/styled';
import chartIconSrc from '../../assets/icon/charts.svg';
// import fileIconSrc from '../../assets/icon/download.svg';
import { useSampleDataContext } from '@resistapp/client/contexts/sample-data-context';
import { ActionButton } from '../buttons/action-button';

export function OverviewActions() {
  const { data } = useSampleDataContext();
  // const isMobile = useBreakpointValue({ base: true, md: false });

  const buttonData = [
    {
      text: 'Analyse in detail',
      alt: 'different kind of charts',
      src: chartIconSrc,
      link: `/research/${data?.id}`,
      size: '32px',
    },
  ];
  return (
    <Container>
      <ActionButton
        text={buttonData[0].text}
        src={buttonData[0].src}
        alt={buttonData[0].alt}
        link={buttonData[0].link}
      />
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  gap: 8px;
`;
